import { store } from 'redux/store';
import { setModal } from 'modules/_shared/redux/modalActions';

import PauseBeneficiaryModal from 'modules/beneficiaries/modals/PauseBeneficiary';

const pauseBeneficiary = (params, beneficiaryId) => {
  const { data } = params;

  store.dispatch(
    setModal(
      <PauseBeneficiaryModal beneficiaryId={beneficiaryId} beneficiary={data} />
    )
  );
};

export default pauseBeneficiary;
